
import axios from 'axios';
import { http } from "@/helpers/http";
import Vue from 'vue'
import APP_URL from "@/helpers/urls";

const baseURL = APP_URL("core-v2");

export default {
    namespaced: true,
    state: {
        dashboardData: null,
        sideNav: true,
        cancelTokenSource: null,
    },

    mutations: {
        setCancelTokenSource(state, cancelTokenSource) {
            state.cancelTokenSource = cancelTokenSource;
        },

        setDashboardData(state, dashboardData) {
            Vue.set(state, 'dashboardData', dashboardData);
        },

        setSideNav(state, sideNav) {
            Vue.set(state, 'sideNav', sideNav);
        },
    },
    actions: {
        showSideNav({ state, commit, rootState }, payload) {
            commit("setSideNav", true);
        },

        hideSideNav({ state, commit, rootState }, payload) {
            commit("setSideNav", false);
        },

        getDashboardData({ state, commit, rootState }, payload) {
            http.get(baseURL + "/dashboard", {
                params: {
                    salesAgent: payload.agents ? true : false,
                    userId: payload.userId
                }
            }).then(response => {
                if (payload.callback) payload.callback(true, response.data);
            }).catch(error => {
                if (payload.callback) payload.callback(false);
            })
        },

        getDashboardDataV2({ state, commit, rootState }, payload) {
            if (state.cancelTokenSource && state.cancelTokenSource.cancel) {
                state.cancelTokenSource.cancel('Cancelled by client');
            }
            let cancelToken = axios.CancelToken;
            commit('setCancelTokenSource', cancelToken.source());

            http.get(`${baseURL}/dashboard-v2?from=${payload.dateRange.from}&to=${payload.dateRange.to}`, { cancelToken: state.cancelTokenSource.token }).then(response => {
                if (payload.callback) payload.callback(true, response.data);
            }).catch(error => {
                if (payload.callback) payload.callback(false);
            })
        }

    }
}